module.exports = __webpack_public_path__ + "img/pic_administration_operate_3.f8c02f81.png";